module.exports = __webpack_public_path__ + "static/media/vehicle_documentation_front.f0f22295.svg";